import { version } from '../../../package.json';
import { cn } from '@utils/cn';
import { FooterProps } from './types';

export const Footer = ({ isCompact, menu }: FooterProps) => {
  if (menu)
    return (
      <footer className="footer flex shrink-0 items-center gap-4 border-t px-[18px] pt-3">
        <img className="h-4 w-auto" src="/logo.png" alt="Retti" />
        <span className="flex flex-1 justify-between font-inter text-xs font-semibold text-neutral-400">
          <span>© 2025 Retti, Inc.</span>
          <span>v{version}</span>
        </span>
      </footer>
    );

  return (
    <footer
      className={cn(
        'footer t-auto flex flex-wrap items-center py-2.5 ',
        isCompact ? 'mx-auto mb-auto w-full max-w-md flex-col' : 'mx-auto w-full px-4',
      )}>
      <div className="mb-2.5 w-full border-t border-neutral-200" />
      <div className={cn('flex flex-1 items-center gap-5', isCompact && 'flex-col')}>
        <img className="h-4 w-auto" src="/logo.png" />
        <span
          className={cn(
            'flex flex-1 justify-between font-inter font-semibold text-neutral-400',
            isCompact && 'flex-col items-center',
          )}>
          <span>© 2025 Retti, Inc.</span>
          <span>v{version}</span>
        </span>
      </div>
    </footer>
  );
};
